export const menu = () => {
  if (document.querySelector('.header--hamburger')) {
    const hamburger = document.querySelector('.header--hamburger');
    const nav = document.querySelector('.header--nav');
    const btnPopieram = document.querySelector('.header__additional_popieram'); // tylko dla skoda
    for (let i = 0; i < 3; i++) {
      const span = document.createElement('span');
      hamburger.appendChild(span);
    }
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('__js_isActive');
      nav.classList.toggle('__js_isActive');
      if(btnPopieram && btnPopieram.classList.contains('__fixed') && getComputedStyle(btnPopieram).zIndex == 12 && nav.classList.contains('__js_isActive')) {
        btnPopieram.style.zIndex = -13;
        btnPopieram.style.right = '-500px';
      } else {
        btnPopieram.style.zIndex = 12;
        btnPopieram.style.right = '';
      }

    });
    nav.querySelector('ul').addEventListener('click', () => {
      nav.classList.remove('__js_isActive');
      hamburger.classList.remove('__js_isActive');
    });
    document.querySelector('.header').addEventListener('mouseleave', () => {
      nav.classList.remove('__js_isActive');
      hamburger.classList.remove('__js_isActive');
    });
  }
};
